
const getSession = function () {
  try {
    return window.$quillnoteSessionId;
  } catch (err) {
    return false;
  }
};

const setSession = function (id) {
  window.$quillnoteSessionId = id;
};

const getStudentId = function(){
  try {
    return window.$studentId;
  } catch (err) {
    return false;
  }
}

const setStudentId = function (id) {
  try {
    window.$studentId = id;
    } catch (err) {
      return false;
    }
};

const getProblemStatement =function(){
  try {
    return window.$problemStatement;
  } catch (err) {
    return false;
  }
}

const setProblemStatement = function (statement) {
  window.$problemStatement = statement;
};

const setAnswer = function(answer){
  window.$answer = answer;
}

const getAnswer = function(){
  try {
    return window.$answer;
  } catch {
    return false;
  }
}


const localStore = {getSession,setSession,getStudentId,setStudentId,getProblemStatement,setProblemStatement,setAnswer,getAnswer};

export {localStore};




